export function reportDebtCollectionTypeOptions(state) {
  const reportDebtCollectionTypeOptions = state.reportDebtCollectionType
    .map(({value, label}) => {
      return {
        label,
        value,
      }
    })
  return reportDebtCollectionTypeOptions || []
}

export function reportOnlyBorrowerOptions(state) {
  const reportOnlyBorrowerOptions = state.reportOnlyBorrower
    .map(({value, label}) => {
      return {
        label,
        value,
      }
    })
  return reportOnlyBorrowerOptions || []
}

export function reportProsecutionFilterOptions(state) {
  const reportProsecutionFilterOptions = state.reportProsecutionFilter
    .map(({value, label}) => {
      return {
        label,
        value,
      }
    })
  return reportProsecutionFilterOptions || []
}
